"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.responseSchema = exports.requestSchema = void 0;
const zod_1 = require("zod");
exports.requestSchema = zod_1.z.object({
    blockIds: zod_1.z.number().array(),
});
exports.responseSchema = zod_1.z
    .array(zod_1.z.object({
    blockId: zod_1.z.number(),
    riskId: zod_1.z.string(),
}))
    .or(zod_1.z.object({
    error: zod_1.z.string(),
}))
    .nullable();
//# sourceMappingURL=fireBlight.js.map